import { Reflection } from './reflection'
import { InformalReflection } from './informal-reflection'
import { UserForegroundDomainEnum } from './user-foreground-domain-enum'

export interface ActivityReflectionInterface {
  activityId: number
  /**
   * 活动关联的人员定义[关联的正式用户]
   */
  reflection?: Reflection
  /**
   * 活动关联的人员定义[关联的非正式用户]
   */
  informalReflection?: InformalReflection
  rid?: number
  reflectionDomain?: UserForegroundDomainEnum
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class ActivityReflection implements ActivityReflectionInterface {
  activityId: number
  /**
   * 活动关联的人员定义[关联的正式用户]
   */
  reflection?: Reflection
  /**
   * 活动关联的人员定义[关联的非正式用户]
   */
  informalReflection?: InformalReflection
  rid?: number
  reflectionDomain?: UserForegroundDomainEnum
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: ActivityReflectionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      activityId: _activityId,
      reflection: _reflection,
      informalReflection: _informalReflection,
      rid: _rid,
      reflectionDomain: _reflectionDomain,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.activityId = _activityId
    this.reflection = _reflection ? new Reflection(_reflection) : _reflection
    this.informalReflection = _informalReflection
      ? new InformalReflection(_informalReflection)
      : _informalReflection
    this.rid = _rid
    this.reflectionDomain = _reflectionDomain
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
